import React from 'react'

const previewThumbs = ({files}) => {
    const thumbs = files.map(file => {    
        return (
            <img key={file.name} src={file.preview} alt={file.name} />
        )
    })

    return <div className="image-display full-width" style={{width: "100%"}}>{thumbs}</div>
}

export default previewThumbs